import axios from 'axios'
import debounce from 'debounce-promise'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { API_HOST } from '../../consts'
import InputAsync from './InputAsync'

const SchoolInput = ({
  basic,
  params,
  label = 'Schools',
  // onChange,
  ...props
}: {
  params?: any
  basic?: boolean
  label?: string
  // onChange?: void
}) => {
  const { t } = useTranslation()

  // eslint-disable-next-line
  const fetchSchools = useCallback(
    debounce(async (search) => {
      const response = await axios.get(
        `${API_HOST}/institucion-users/user_schools`,
        {
          params: {
            search,
            ...params
          }
        }
      )
      return response.data
    }, 500),
    [params]
  )

  return (
    <InputAsync
      key={JSON.stringify(params)}
      defaultOptions
      loadOptions={fetchSchools}
      label={t(label)}
      name="school"
      getOptionValue={(d) => d.id}
      getOptionLabel={(d) => d.name}
      {...props}
    />
  )
}

export default SchoolInput
